(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fixed-panel"] && !Shopify.designMode) return;
  try {
    window.addEventListener('scroll', function () {
    const targetElement = document.querySelector('.fixed-panel'); // Replace with your selector
    if (window.scrollY >= 100) {
      targetElement.classList.add('scrolled');
    } else {
      targetElement.classList.remove('scrolled');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-header"] && !Shopify.designMode) return;
  try {
    let searchFormElement = document.getElementById("search-from-toggle");
  let searchFormContainer = document.getElementById("search-form-container");
  searchFormElement.addEventListener('click',function(){
    searchFormContainer.style.display = "unset";
    searchFormElement.style.display = "none"
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nav-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
 let special_offers_html = document.querySelector('.special-offers-container');
 document.querySelector('.special-offers-display').innerHTML = special_offers_html.innerHTML;
 special_offers_html.style.display = "none"
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["submenu-item-with-parent"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const allMenus = window.menuData;
  // console.log(allMenus)

  Object.entries(allMenus).forEach(([blockId, menus]) => {
    function renderSubmenu(menu) {
 
      let html = `
      <div class="col-12 col-md-3 item item__2 w-300px level-2 lvl-2" menu-name="${menu.handle}-${blockId}" submenu-order="2" parent-id="${menu.id}">
        <div class="item__1__group">
          <div class="submenu__heading heading__1">
            <h3 class="uppercase">${menu.title}</h3>
          </div>
          <ul class="submenu__items level-2 submenu-inner">
      `;

      menu.items.forEach((top) => {
        let hasChildren = Array.isArray(top.children) && top.children.length;
        html += `
        <li class="${hasChildren ? 'submenu-with-children' : ''}" submenu-order="2">
          <a href="${top.url}">${top.title}</a>
        `;

        if (hasChildren) {
          html += `
          <div class="submenu-items-container style-2 w-300px lvl-3" submenu-order="3">
            <div class="submenu__heading"><h3>${top.title}</h3></div>
            <ul class="submenu__items item">
          `;

          top.children.forEach((child) => {
            let hasSubChildren = Array.isArray(child.children) && child.children.length;
            html += `<li submenu-order="3" class="has-third-level ${hasSubChildren ? 'submenu-with-children' : ''}">
              <a href="${child.url}">${child.title}</a>
            `;

            if (hasSubChildren) {
              html += `
              <ul class="style-2 w-300px submenu-items-container lvl-4" submenu-order="4">
                <div class="submenu__heading"><h3>${child.title}</h3></div>
              `;
              child.children.forEach((sub) => {
                html += `<li submenu-order="4" class="menu-item-last-child"><a href="${sub.url}">${sub.title}</a></li>`;
              });
              html += `</ul>`;
            }

            html += `</li>`;
          });

          html += `</ul></div>`;
        }

        html += `</li>`;
      });

      html += `</ul></div></div>`;
      return html;
      
    }

    let renderedHTML = '';
    Object.values(menus).forEach((menu) => {
      renderedHTML += renderSubmenu(menu);
    });

    const container = document.getElementById(`render-submenus-parent`);
    if (container) container.innerHTML += renderedHTML;
  });

});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["submenu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  // mobile
  window.addEventListener("resize", function () {
    if (window.innerWidth <= 768) {
      document.querySelector('.nav-menu').classList.add('hidden')
    } else {
      document.querySelector('.nav-menu').classList.remove('hidden')
    }
  });

  const allMenus = window.menuData;
  Object.entries(allMenus).forEach(([blockId, menus]) => {
    function renderSubmenu(menu) {
      let html = `
        <div class="col-12 col-md-3 item item__2 w-300px level-2 lvl-2" menu-name="${menu.handle}-${blockId}" submenu-order="2" container-level="2">
          <div class="item__1__group">
            <div class="submenu__heading heading__1">
              <h3 class="uppercase">${menu.name}</h3>
              <a href="/collections/${menu.handle}" class="see-all-link">View All</a>
            </div>
            <ul class="submenu__items level-2 submenu-inner">
      `;
      menu.items.forEach(top => {
        let additionalClass1 = top.children?.length ? "submenu-with-children" : "";
        html += `
          <li class="${additionalClass1}" submenu-order="2">
            <a href="${top.url}">${top.title}</a>
        `;

        if (top.children?.length) {
          html += `
            <div class="submenu-items-container style-2 w-300px lvl-3" submenu-order="3" container-level="3">
              <div class="submenu__heading"><h3>${top.title}</h3></div>
              <ul class="submenu__items item">
          `;

          top.children.forEach(child => {
            let additionalClass = child.children?.length ? "submenu-with-children" : "";
            html += `<li submenu-order="3" class="has-third-level ${additionalClass}"><a href="${child.url}">${child.title}</a>`;

            if (child.children?.length) {
              html += `
                <ul class="style-2 w-300px submenu-items-container lvl-4" submenu-order="4">
                  <div class="submenu__heading"><h3>${child.title}</h3></div>
              `;
              child.children.forEach(sub => {
                html += `<li submenu-order="4" class="menu-item-last-child"><a href="${sub.url}">${sub.title}</a></li>`;
              });
              html += `</ul>`;
            }

            html += `</li>`;
          });

          html += `</ul></div>`;
        }

        html += `</li>`;
      });

      html += `</ul></div></div>`;
      return html;
    }
    let renderedHTML = '';
    Object.values(menus).forEach(menu => {
      renderedHTML += renderSubmenu(menu);
    });
    const container = document.getElementById(`render-submenus-${blockId}`);
      if (container) container.innerHTML = renderedHTML;
    });
  
  const triggerItems = document.querySelectorAll(`.submenu-items-name`);
  const allSubmenus = document.querySelectorAll('.item__2[menu-name]');
  let with5th_lvl = false;
  triggerItems.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      const menuKey = trigger.getAttribute('submenu-items');
      const block_id = trigger.getAttribute('block-id');
      const menu_id = trigger.getAttribute('menu-id');
      const subMenuContainer = this.closest('.item');
      
      if(subMenuContainer){
        subMenuContainer.classList.remove('hidden')
        if(window.innerWidth <= 768){
          subMenuContainer.classList.add('hidden')
        }
      }
      
      

      // Hide all
      allSubmenus.forEach(sub => {
        sub.style.display = 'none';
      });
      
      let currentItemlvl = 0;
      with5th_lvl = false;
      if(menu_id && document.querySelector(`.extra-columns[menu-id="${menu_id}"]`)){

        with5th_lvl = true;
        document.querySelectorAll('.submenu__items.lvl-1 .submenu-items-name').forEach(i => i.classList.remove('activeMenuItem'));
     
        e.target.classList.add('activeMenuItem');
        if(window.innerWidth <= 768){
          document.querySelector('.row > .item__1').classList.add('hide-main');
        }
        let submenuItem = document.querySelector(`.extra-columns[menu-id="${menu_id}"]`);
        const menuTitle = trigger.getAttribute('target-id');
        const triggerURL = trigger.getAttribute('target-url');
        let viewAll = '';
        if(triggerURL!==null || triggerURL!==''){
        viewAll = `<a href="${triggerURL}" class="see-all-link">View All</a>`
        }
        submenuItem.setAttribute('menu-title',menuTitle)
        submenuItem.querySelector('.submenu__heading').innerHTML = `<h3 class="heading__1 uppercase">${menuTitle}</h3>${viewAll}`;
        resetSubmenuExtra()
        LoadExtraColContainer()
        submenuItem.style.display = "block"
      }else{
        document.querySelector('.row > .item__1').classList.remove('hide-main')
        CloseExtraColContainer()
      }
      // Show only the matched one
      const target = document.querySelector(`.item__2[menu-name="${menuKey}-${block_id}"]`);
      // console.log(target)
      if (target) {
        target.style.display = 'block';
      }
    });
  });
  function LoadExtraColContainer(){
     let extraColumnsOutputDiv = document.getElementById('extra-columns-display-container'); 
     extraColumnsOutputDiv.style.display = "block";
  }
  function CloseExtraColContainer(){
     let extraColumnsOutputDiv = document.getElementById('extra-columns-display-container'); 
     extraColumnsOutputDiv.style.display = "none";
  }
  function resetSubmenuExtra(){
    let extraCols = document.querySelectorAll('div.extra-columns')
    extraCols.forEach((el)=>{
      el.style.display = "none"
    })
  }
  let currentMenuActive = '';
  let isActive = false;
  let menuHistory = [];
  function loadSubmenuItems() {
    allSubmenus.forEach(sub => sub.style.display = 'none');
    
    setTimeout(() => {
      let submenuChildrens = document.querySelectorAll('.submenu-with-children');
      
      submenuChildrens.forEach((item) => {
        item.addEventListener('click', function(e) {
          const subMenuContainer = this.closest('.item');
         
          if (e.target.classList.contains('submenu-items-name')) {
            removeActiveClass();
            e.target.classList.add('activeMenuItem');
          }
          currentMenuActive = e.target.getAttribute('submenu-order');
          if (window.innerWidth <= 768) {
            if (currentMenuActive == 1) {
              // document.querySelector('.item__1').style.display = "none";
            } else if (currentMenuActive == 2) {
              // document.querySelector('.item__1').style.display = "none";
            }
          }else{
            if (currentMenuActive == 3 && with5th_lvl) {
              if(window.innerWidth > 768){
                document.querySelector('.item__1').style.display = "none";  
              }
            }
          }

          ReloadSubmenu(currentMenuActive);
          let submenu = e.target.querySelector('.submenu-items-container');
          if (submenu) {
            submenu.style.display = 'block';
            menuHistory.push(submenu);
          }else{
            menuHistory.push(subMenuContainer);
          }
        
        });
      });
    }, 1000);
  }

  function LoadMenuJs() {
  let menuItems = document.querySelectorAll('.header-group .menu-items-main li');
  menuItems.forEach((item) => {
    if (item.classList.contains('has-sub') && !item.hasAttribute('data-bound')) {
      let menuClass = item.getAttribute('child-menu-id');
      let mainHeader = item.closest('.header-group');
      let submenuElement = mainHeader?.querySelector('.' + menuClass);
      if (menuClass && submenuElement) {
        item.addEventListener('click', function (e) {
         
          const navMenu = this.closest('.nav-menu');
          if(window.innerWidth <= 768){
            if(navMenu){
              document.querySelector('.go-back-menu').classList.remove('hidden')
              navMenu.classList.add('hidden')
            }
          }
          // Remove active classes from all menus
          reloadMenuItemsMain(mainHeader);
          isActive = !isActive;
          let submenuEl = document.querySelector('.submenu');
         
          if (submenuEl && !submenuEl.classList.contains('active')) {
              submenuEl.classList.add('active');
          }
          // Activate clicked item and its submenu
          if (window.innerWidth <= 768) {
            document.querySelector('.header-bottom').classList.add('hidden');
          }
          if(isActive){
            item.classList.add('active');
            submenuElement.classList.add('active');
          }else{
            item.classList.remove('active');
            submenuElement.classList.remove('active');
          }
        });
        item.setAttribute('data-bound', 'true');
      }
    }
  });
}

function reloadMenuItemsMain(context) {
  let submenuItems = context.querySelectorAll('.submenu');
  let menuItems = context.querySelectorAll('.has-sub');

  menuItems.forEach((item) => item.classList.remove('active'));
  submenuItems.forEach((submenu) => submenu.classList.remove('active'));
}

  let stickyAdded = false;
  let ActiveClass = false;
  let ElementClonedDetected = false;
  // for sticky header
  function LoadStickyMenuJs() {
    if (document.querySelector('#header-ontop.cloned')) {
      ElementClonedDetected = true;
      let menuItems = document.querySelectorAll('.cloned .header-group .menu-items-main li');
      menuItems.forEach((item) => {
        if (item.classList.contains('has-sub')) {
          let menuClass = item.getAttribute('child-menu-id');
          let mainHeader = document.querySelector('.cloned .header-group');
          let submenuElement = mainHeader?.querySelector('.' + menuClass);
          item.addEventListener('click', function () {
            console.log('clicked cloned');
            if (ActiveClass) {
              submenuElement.classList.remove('active');
              item.classList.remove('active');
              ActiveClass = false;
            } else {
              submenuElement.classList.add('active');
              item.classList.add('active');
              ActiveClass = true;
            }
          });
        }
      });
    }
  }

  const stickyInterval = setInterval(() => {
    if (ElementClonedDetected == true) {
      clearInterval(stickyInterval);
    } else {
      LoadStickyMenuJs();
    }
  }, 900);

  LoadMenuJs();

   let main_nav_items = document.querySelectorAll('.mobile-main-header .menu-items-main li');
  main_nav_items.forEach((element) => {
    element.addEventListener('click', function () {
      if (element.getAttribute('child-menu-id') != '') {
        let submenuAttribute = element.getAttribute('child-menu-id');
        document.querySelector(`.mb-header .${submenuAttribute}`).classList.add('active');
      }
    });
  });
  let toggleMenuIcons = document.querySelectorAll('.toggle-menu');
  let menuStatus = false;
  if (window.innerWidth <= 768) {
    document.querySelector('.nav-menu').classList.add('hidden');
  }
  toggleMenuIcons.forEach((el) => {
    el.addEventListener('click', function (e) {
      menuStatus = !menuStatus;
      if(menuStatus){
        document.querySelector('.close-menu').classList.remove('hidden')
        document.querySelector('.open-menu').classList.add('hidden')
        document.querySelector('.nav-menu').classList.remove('hidden')
       
        document.querySelector('.item__1 ').classList.remove('hide-main')
        document.querySelectorAll('.item__1 ').forEach(el => el.classList.remove('hidden'))
      }else{
        console.log('close');
        isActive = false;
        console.log(isActive);
        document.querySelector('.go-back-menu').classList.add('hidden')
        
        // window.location.reload()
        document.querySelectorAll('.lvl-2').forEach(el => el.style.display = "none")
        document.querySelectorAll('.lvl-3').forEach(el => el.style.display = "none")
        document.querySelector('.item__1 ').classList.remove('hide-main')
        document.querySelectorAll('.has-sub').forEach(el => el.classList.remove('active'))
        document.querySelector('.submenu').classList.remove('active')
        document.querySelector('.close-menu').classList.add('hidden')
        document.querySelector('.open-menu').classList.remove('hidden')
        document.querySelector('.nav-menu').classList.add('hidden')
      }
    });
  });
  let closeMenu = document.querySelector('.close-menu');
  closeMenu.addEventListener('click',function(){
    // document.querySelector('.item__1').style.display = "none"
  })
      // Back button logic
    let menuContainer = 0;
    document.querySelector('.back-btn').addEventListener('click', () => {
      console.log("back clicked");
      
      if (menuHistory.length > 0) {
        menuContainer = 0;
        let historyItem = menuHistory[menuHistory.length-1];
        if(historyItem.classList.contains('hide-main')){
          historyItem.classList.remove('hide-main')
        }
        menuHistory[menuHistory.length-1].style.display = 'none'
        menuHistory.pop();
      }else{
        document.querySelector('.submenu').classList.add('active')
        document.querySelector('.item__1').classList.remove('hidden')
        document.querySelector('.item__1').style.display = "block";
        document.querySelectorAll('.item__2').forEach(el=>{
          el.style.display = "none";
        })
      }
     
      
      if(menuHistory.length == 0){
        console.log(menuHistory );
        document.querySelector('.submenu').classList.add('active')
        document.querySelectorAll('.has-sub').forEach(el => el.classList.remove('active'))
        menuContainer++;
        console.log(menuContainer);
        
        if(menuContainer == 3){
          // document.querySelector('.item__1').style.display = "none";
          document.querySelector('.nav-menu').classList.remove('hidden')
        }
      }
    });
  


  loadSubmenuItems();
  function removeActiveClass(){
    let submenuChildrens = document.querySelectorAll('.submenu-items-name');
    submenuChildrens.forEach((item)=>{
       item.classList.remove('activeMenuItem')
    })
  }
  function clearSubmenuActive(exceptItem) {
  submenuChildrens.forEach((item) => {
    if (item !== exceptItem) {
      let submenu = item.querySelector('.submenu-items-container');
      if (submenu) submenu.style.display = 'none';
    }
  });
  }
  function ReloadSubmenu(activeMenu){
     if(activeMenu == '2'){
       hideSubmenuContainer(document.querySelectorAll(".lvl-3"))
       hideSubmenuContainer(document.querySelectorAll(".lvl-4"))
     }
     else if(activeMenu == '3'){
       hideSubmenuContainer(document.querySelectorAll(".lvl-4"))
     }
    else if(activeMenu == '1'){
       // hideSubmenuContainer(document.querySelectorAll(".lvl-2"))
       // hideSubmenuContainer(document.querySelectorAll(".lvl-3"))
       // hideSubmenuContainer(document.querySelectorAll(".lvl-4"))
      
    }else{
      console.log('active undefined')
    }
    }
  function hideSubmenuContainer(Elements){
    Elements.forEach(el => {
          el.style.display = "none";
      });
  }
  AddhoverEffects()
function AddhoverEffects() {
  let liElements = document.querySelectorAll('.submenu .row .item .submenu__items.submenu-inner li');

  liElements.forEach((element) => {
    element.addEventListener('mouseover', function (e) {
      // Remove 'active-list' from all items
      liElements.forEach(el => el.classList.remove('active-list'));

      // Add 'active-list' to the currently hovered item
      e.currentTarget.classList.add('active-list');
    });
  });
}

  // Close menu when clicking outside
  function closeAllMenus() {
    // Close all submenus
    document.querySelectorAll('.item__2').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.lvl-3').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.lvl-4').forEach(el => el.style.display = 'none');
    
    // Remove active classes
    document.querySelectorAll('.submenu-items-name').forEach(el => el.classList.remove('activeMenuItem'));
    document.querySelectorAll('.has-sub').forEach(el => el.classList.remove('active'));
    
    // Close submenu container
    const submenuEl = document.querySelector('.submenu');
    if (submenuEl) {
      submenuEl.classList.remove('active');
    }
    
    // Close extra columns container
    CloseExtraColContainer();
    
    // Reset menu history
    menuHistory = [];
    
    // Reset main item visibility
    document.querySelectorAll('.item__1').forEach(el => {
      el.classList.remove('hide-main');
      el.classList.remove('hidden');
    });
    
    // Reset active state
    isActive = false;
    with5th_lvl = false;
  }

  // Add click outside listener - close if click is not on submenu children
  // Only elements inside submenu-container > row > * are considered children
  document.addEventListener('click', function(e) {
    const submenu = document.querySelector('.submenu');
    
    // Check if submenu is active
    if (!submenu || !submenu.classList.contains('active')) return;
    
    const clickedElement = e.target;
    
    // Check if click is inside submenu-container > row > * (direct children of row)
    const allSubmenuContainers = document.querySelectorAll('.submenu-container');
    let isInsideSubmenuContent = false;
    
    allSubmenuContainers.forEach(container => {
      const row = container.querySelector('.row');
      if (row) {
        // Get all direct children of the row
        const rowChildren = Array.from(row.children);
        
        // Check if clicked element is inside any of the row's direct children
        rowChildren.forEach(child => {
          if (child.contains(clickedElement) || child === clickedElement) {
            isInsideSubmenuContent = true;
          }
        });
      }
    });
    
    // Check if click is on menu trigger (should not close when opening menu)
    const menuTrigger = clickedElement.closest('.has-sub');
    
    // Close if click is NOT inside submenu-container > row > * AND not clicking on menu trigger
    if (!isInsideSubmenuContent && !menuTrigger) {
      closeAllMenus();
    }
  });

});
  } catch(e) { console.error(e); }
})();

})();
